import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface LinkButtonProps {
    children: React.ReactNode;
    disabled?: boolean;
    onClick(): void;
    icon?: React.ReactNode;
}

export function LinkButton({
    children,
    disabled,
    onClick,
    icon
}: LinkButtonProps) {
    return (
        <span
            className={classNames(styles.root, { [styles.disabled]: disabled })}
            onClick={disabled ? undefined : onClick}>
            {icon && <span>{icon} </span>}

            {children}
        </span>
    );
}
